import { Button, Modal } from 'antd';
import React, { useState } from 'react';

const DeleteModalStage = ({
  showModal = false,
  setShowModal,
  title,
  name,
  deleteStage,
  mutationId,
  setMutationId,
}) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleOk = async () => {
    if (!mutationId || isDeleting) return;
    setIsDeleting(true);
    try {
      await deleteStage({
        variables: {
          id: mutationId,
        },
      });
    } finally {
      setIsDeleting(false);
    }
  };

  const handleCancel = () => {
    setMutationId('');
    setShowModal(false);
  };
  return (
    <div id="delete-stage-modal-wrapper">
      <Modal
        id="delete-stage-modal"
        maskClosable={false}
        centered
        closable={false}
        footer={null}
        open={showModal}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <h2 id="delete-stage-modal-title">{`Remove ${title}`}</h2>
        <p id="delete-stage-confirmation-text">
          Are you sure you want to remove {name}?
        </p>
        <div id="delete-stage-form-buttons" className="form-buttons">
          <Button
            id="delete-stage-cancel-btn"
            shape="round"
            className="cancel-button"
            onClick={handleCancel}
          >
            No, Cancel
          </Button>
          <Button
            id="delete-stage-confirm-btn"
            shape="round"
            type="primary"
            className="save-button"
            onClick={handleOk}
            loading={isDeleting}
            disabled={isDeleting}
          >
            Yes, Remove
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default DeleteModalStage;
